import React from 'react';

// Internal Import
import { deep } from '../theme/colors';
import { AppBarComponent } from '../components/appbar';
import { FooterComponent } from '../components/footer';
import { TypeSelect } from '../modules/types/home.type';
import { ScrollToTopComponent } from '../components/scrollToTop';

// External Import
import moment from 'moment';
import { common } from "@mui/material/colors";
import { Link, useNavigate } from 'react-router-dom';
import ImageList from '@mui/material/ImageList';
import SwipeableViews from 'react-swipeable-views';
import { ReactSession } from 'react-client-session';
import { formatRupiah } from '../utils/format-rupiah';
import { autoPlay } from 'react-swipeable-views-utils';
import ImageListItem from '@mui/material/ImageListItem';
import MobileStepper from '@mui/material/MobileStepper';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';


import {
    Box,
    Grid,
    Stack,
    Button,
    Typography,
} from '@mui/material';
import { ResponseLoginData, defaultLoginData } from '../modules/types/login.type';



const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const arrType: TypeSelect[] = [
    {
        id: "1",
        name: "Residential"
    },
    {
        id: "2",
        name: "Commercial"
    },
    {
        id: "3",
        name: "Apartment"
    }
];

const arrHarga: TypeSelect[] = [
    {
        id: "100000000",
        name: "100 Juta"
    },
    {
        id: "200000000",
        name: "200 Juta"
    },
    {
        id: "300000000",
        name: "300 Juta"
    },
    {
        id: "400000000",
        name: "400 Juta"
    },
    {
        id: "500000000",
        name: "500 Juta"
    }
]

const dataLocation = [
    {
        img: require('./../asset/Jabodetabek.jpeg'),
        title: 'Jabodetabek',
        rows: 2,
        cols: 2,
    },
    {
        img: require('./../asset/Malang.jpeg'),
        title: 'Kota Malang',
        cols: 2,
    },
    {
        img: require('./../asset/KalTim.png'),
        title: 'Kalimantan Timur',
    },
    {
        img: require('./../asset/KalBar.png'),
        title: 'Kalimatan Barat',
    },
    {
        img: require('./../asset/Jambi.jpeg'),
        title: 'Jambi',
    },
    {
        img: require('./../asset/Batam.png'),
        title: 'Batam',
    },
];

const dataPromotions = [
    {
        id: 1,
        name: 'San Francisco – Oakland Bay Bridge, United States',
        img: require('./../asset/Garden_Ville_at_Agate.png')
    }
];

const dataProduct = [
    {
        id: 3,
        name: 'cluster varena',
        proyek: 'citraraya tangerang',
        desc: 'Cluster EcoResidence di Ecopolis at CitraRaya Tangerang. Cluster ekslusif persembahan dari Ciputra Group dan Mitsui Fudosan Asia.',
        price: "500000000",
        img: require('./../asset/Varrena.jpg')
    },
];

const responseProduct = {
    status: 200,
    message: "successful",
    data: dataProduct,
    page: 1,
    next: false
}

const dataWhatsOn = [
    {
        id: 1,
        title: 'Dukung Program Kendaraan Listrik, Pemkab Tangerang Siapkan SPKLU di Mal Ciputra Tangerang',
        desc: '',
        img: 'https://citraraya.com/wp-content/uploads/2023/02/63fd6e994ae4e.jpeg',
        source: 'https://citraraya.com/spklu-ada-di-citraraya-tangerang/',
        created_at: "2023-02-28 08-00-00",
        updated_at: "2023-02-28 08-00-00",
    },
    {
        id: 2,
        title: 'Ini Kenyamanan dan Keunggulan Rumah dengan Attic Room',
        desc: '',
        img: 'https://citraraya.com/wp-content/uploads/2022/11/vr-neo-pine-tree.jpg',
        source: 'https://citraraya.com/rumah-idaman-attic-room-neo-pine-tree/',
        created_at: "2023-02-13 09-00-00",
        updated_at: "2023-02-13 09-00-00",
    }
]



export interface HomeProps { }
export const HomeScreen: React.FC<HomeProps> = () => {

    let navigate = useNavigate();

    const [userAuth, setUserAuth] = React.useState<ResponseLoginData>(defaultLoginData);

    const [search, setSearch] = React.useState<string>('');
    const handleSearch = () => {
        if (search == "" && idType == "0" && idPriceMin == "0" && idPriceMax == "0") {
            navigate("/products");
            return;
        }

        if (search == "") {
            navigate(`/products/${idType}/${idPriceMin}/${idPriceMax}`);
        } else {
            navigate(`/products/${search}/${idType}/${idPriceMin}/${idPriceMax}`);
        }

        return;
    }

    const [idType, setIdType] = React.useState<string>('0');
    const [idPriceMin, setIdPriceMin] = React.useState<string>('0');
    const [idPriceMax, setIdPriceMax] = React.useState<string>('0');
    const [dataType, setDataType] = React.useState<TypeSelect[]>(arrType);
    const [dataPriceMin, setPriceMin] = React.useState<TypeSelect[]>(arrHarga);
    const [dataPriceMax, setPriceMax] = React.useState<TypeSelect[]>(arrHarga);
    React.useEffect(() => {
        if (idPriceMin != "0") {
            let priceMax: TypeSelect[] = arrHarga.filter(o => parseInt(o.id) > parseInt(idPriceMin));
            setIdPriceMax("0");
            setPriceMax(priceMax);
        }
    }, [idPriceMin]);

    function srcset(image: string, size: number, rows = 1, cols = 1) {
        return {
            src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
            srcSet: `${image}?w=${size * cols}&h=${size * rows
                }&fit=crop&auto=format&dpr=2 2x`,
        };
    }

    const [activeStep, setActiveStep] = React.useState(0);
    const maxSteps = dataPromotions.length;
    const handleStepChange = (step: number) => {
        setActiveStep(step);
    };

    React.useEffect(() => {
        if (ReactSession.get("user_auth") == true) { setUserAuth(ReactSession.get("user_data")); }
    }, []);



    return (
        <Stack>
            <AppBarComponent />

            {/* // Banner Content // */}
            <Box
                sx={{
                    width: '96%',
                    objectFit: 'cover',
                    marginTop: 4,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    borderRadius: 1.5,
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundImage: 'url(./assets/images/masterplan.jpg)'
                }}
            >
                <Box
                    sx={{
                        flex: '1',
                        display: 'flex',
                        borderRadius: 1.5,
                        flexDirection: 'column',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(0, 0, 0, 0.2)'
                    }}
                >

                    <Typography
                        color={common.white}
                        sx={{

                            width: '90%',
                            fontWeight: '500',
                            lineHeight: '1.1em',
                            fontFamily: 'Montserrat',
                            textTransform: 'capitalize',

                            marginTop: 8,
                            marginBottom: 2.6,
                            marginLeft: 'auto',
                            marginRight: 'auto',

                            fontSize: { xs: '1.75em', sm: '2.5em', md: '3em' },
                        }}
                    >
                        Find Your<br />
                        <span style={{ fontWeight: '800' }}>Dream Property</span><br />
                        Today.
                    </Typography>

                    <Grid container sx={{
                        width: '90%',
                        borderRadius: 1,
                        marginBottom: 6,
                        marginLeft: 'auto',
                        marginRight: 'auto',

                        paddingTop: 1,
                        paddingBottom: 2,

                        justifyContent: 'space-evenly',
                        backgroundColor: 'rgba(217, 217, 217, 0.8)'
                    }}>
                        <Grid item xs={11} sm={11} md={3} sx={{
                            marginTop: 1,
                            paddingLeft: 1,
                            borderRadius: 1,
                            display: 'flex',
                            paddingRight: 1,
                            alignItems: 'center',
                            flexDirection: 'row',
                            height: { xs: 42, sm: 48 },
                            backgroundColor: common.white,
                        }}>
                            <SearchRoundedIcon sx={{ width: 24, fill: deep.main }} />
                            <input
                                type='text'
                                value={search}
                                placeholder='Search location/proyek'
                                onChange={(e) => setSearch(e.target.value)}
                                style={{
                                    flex: 1,
                                    width: '100%',
                                    marginLeft: 4,
                                    height: '100%',
                                    border: 'unset',
                                    outline: 'unset',
                                    fontSize: '0.8em',
                                    fontFamily: 'Montserrat',
                                    backgroundColor: 'transparent',
                                }}
                            />
                        </Grid>
                        <Grid item xs={11} sm={3.6} md={1.75} sx={{
                            marginTop: 1,
                            paddingLeft: 1,
                            borderRadius: 1,
                            display: 'flex',
                            paddingRight: 1,
                            alignItems: 'center',
                            flexDirection: 'row',
                            height: { xs: 42, sm: 48 },
                            backgroundColor: common.white,
                        }}>
                            <select
                                value={idType}
                                onChange={e => setIdType(e.target.value)}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    border: 0,
                                    outline: 0,
                                    font: 'inherit',
                                    cursor: 'pointer',
                                    fontSize: '0.8em',
                                    textAlign: 'center',
                                    fontFamily: 'Montserrat',
                                    backgroundColor: 'transparent',
                                    color: parseInt(idType) == 0 ? "rgba(0,0,0,0.5)" : common.black
                                }}
                            >
                                <option disabled selected value="0">- Type Property -</option>
                                {dataType.map((item: TypeSelect, index: number) => {
                                    return (
                                        <option 
                                            key={item.id} 
                                            value={item.id}
                                            style={{backgroundColor: 'transparent'}}
                                        >{item.name}</option>
                                    );
                                })}

                            </select>
                        </Grid>
                        <Grid item xs={11} sm={3.6} md={1.75} sx={{
                            marginTop: 1,
                            paddingLeft: 1,
                            borderRadius: 1,
                            display: 'flex',
                            paddingRight: 1,
                            alignItems: 'center',
                            flexDirection: 'row',
                            height: { xs: 42, sm: 48 },
                            backgroundColor: common.white,
                        }}>
                            <select
                                value={idPriceMin}
                                onChange={e => setIdPriceMin(e.target.value)}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    border: 0,
                                    outline: 0,
                                    font: 'inherit',
                                    cursor: 'pointer',
                                    fontSize: '0.8em',
                                    textAlign: 'center',
                                    fontFamily: 'Montserrat',
                                    backgroundColor: 'transparent',
                                    color: parseInt(idPriceMin) == 0 ? "rgba(0,0,0,0.5)" : common.black
                                }}
                            >
                                <option disabled selected value="0">- Min Price -</option>
                                {dataPriceMin.map((item: TypeSelect, index: number) => {
                                    return (
                                        <option 
                                            key={item.id} 
                                            value={item.id}
                                            style={{backgroundColor: 'transparent'}}
                                        >{item.name}</option>
                                    );
                                })}

                            </select>
                        </Grid>
                        <Grid item xs={11} sm={3.6} md={1.75} sx={{
                            marginTop: 1,
                            paddingLeft: 1,
                            borderRadius: 1,
                            display: 'flex',
                            paddingRight: 1,
                            alignItems: 'center',
                            flexDirection: 'row',
                            height: { xs: 42, sm: 48 },
                            backgroundColor: common.white,
                        }}>
                            <select
                                value={idPriceMax}
                                onChange={e => setIdPriceMax(e.target.value)}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    border: 0,
                                    outline: 0,
                                    font: 'inherit',
                                    cursor: 'pointer',
                                    fontSize: '0.8em',
                                    textAlign: 'center',
                                    fontFamily: 'Montserrat',
                                    backgroundColor: 'transparent',
                                    color: parseInt(idPriceMax) == 0 ? "rgba(0,0,0,0.5)" : common.black
                                }}
                            >
                                <option disabled selected value="0">- Max Price -</option>
                                {dataPriceMax.map((item: TypeSelect, index: number) => {
                                    return (
                                        <option 
                                            key={item.id} 
                                            value={item.id} 
                                            style={{backgroundColor: 'transparent'}}
                                        >{item.name}</option>
                                    );
                                })}

                            </select>
                        </Grid>
                        <Grid item xs={11} sm={11} md={1.75} sx={{
                            marginTop: 1,
                            borderRadius: 1,
                            height: { xs: 42, sm: 48 },
                            backgroundColor: common.white,
                        }}>
                            <Button
                                onClick={handleSearch}
                                sx={{
                                    flex: 1,
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: 1,
                                    fontSize: '0.8em',
                                    color: common.white,
                                    backgroundColor: '#003974'
                                }}
                            >Submit</Button>
                        </Grid>

                        {/* <Button
                                onClick={() => { }}
                                sx={{
                                    width: 160,
                                    height: 52,
                                    borderRadius: 1,
                                    color: common.white,
                                    backgroundColor: '#003974'
                                }}
                            >Submit</Button> */}
                    </Grid>
                </Box>
            </Box>

            {/* // Discover Our Project // */}
            <Box
                sx={{
                    width: '96%',
                    display: 'flex',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    alignItems: 'center',
                    flexDirection: 'column',
                    marginTop: { xs: 6, lg: 10 },
                }}
            >
                <Typography
                    color={common.black}
                    sx={{
                        mb: 2,
                        fontSize: { xs: 10, sm: 18, md: 20 },
                        fontWeight: '500',
                        fontFamily: 'Montserrat',
                        textTransform: 'uppercase',
                    }}
                >
                    discover our projects
                </Typography>

                <Box sx={{
                    width: '78%',
                    display: { xs: 'none', sm: 'none', md: 'block' }
                }}>
                    <ImageList
                        variant="quilted"
                        cols={5}
                        style={{ width: '100%' }}
                        rowHeight={180}
                    >
                        {dataLocation.map((item) => (
                            <ImageListItem
                                key={item.img}
                                cols={item.cols || 1}
                                rows={item.rows || 1}
                            >
                                <div style={{ 
                                    width: '100%', 
                                    height: '100%',
                                    position: 'absolute',  
                                    backgroundColor: 'transparent'
                                }}>
                                    <Typography
                                        color={common.black}
                                        sx={{
                                            width: '100%',
                                            height: '100%',
                                            fontWeight: 'bold',
                                            fontFamily: 'Roboto',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: { md: item.cols==2?36:20, color: '#ffffff' },
                                        }}
                                    >
                                        {item.title}
                                    </Typography>
                                </div>
                                <img
                                    {...srcset(item.img, 180, item.rows, item.cols)}
                                    alt={item.title}
                                    loading='lazy'
                                    style={{ borderRadius: '0.7em' }}
                                />
                                
                            </ImageListItem>
                        ))}
                    </ImageList>
                </Box>

                <Grid container sx={{
                    width: '78%',

                    paddingTop: 1,
                    paddingBottom: 2,

                    flexDirection: 'row',
                    display: { xs: 'flex', sm: 'flex', md: 'none' },
                    justifyContent: 'space-between',
                }}>
                    {dataLocation.map((item) => {
                        return (
                            <Grid item xs={3.83} sm={3.83} sx={{
                                width: '100%',
                                height: '100%',
                                borderRadius: 1,
                            }}>
                                <Box
                                    sx={{ 
                                        height: 80,
                                        width: '100%', 
                                        borderRadius: 1,
                                        marginBottom: 0.7,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundImage: `url(${item.img})`
                                    }}
                                >
                                    <Typography
                                        color={common.black}
                                        sx={{
                                            fontWeight: 'bold',
                                            fontFamily: 'Roboto',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: 8.5,
                                            color: '#ffffff'
                                        }}
                                    >
                                        {item.title}
                                    </Typography>
                                </Box>
                            </Grid>
                        )
                    })}
                </Grid>

            </Box>

            {/* // Promotions // */}
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    paddingTop: 4,
                    paddingBottom: 4,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    alignItems: 'center',
                    flexDirection: 'column',
                    backgroundColor: '#F5F5F5',
                    marginTop: { xs: 6, lg: 10 },
                }}
            >
                <Typography
                    color={common.black}
                    sx={{
                        mb: 2,
                        fontWeight: '500',
                        fontFamily: 'Montserrat',
                        textTransform: 'uppercase',
                        fontSize: { xs: 10, sm: 18, md: 20 },
                    }}
                >
                    promotions
                </Typography>

                <Box sx={{
                    width: '94%',
                    display: 'flex',
                    flexDirection: 'column',
                }}>

                    <AutoPlaySwipeableViews
                        axis={'x'}
                        index={activeStep}
                        onChangeIndex={handleStepChange}
                        enableMouseEvents
                    >
                        {dataPromotions.map((step, index) => (
                            <div key={step.id}>
                                {Math.abs(activeStep - index) <= 2 ? (
                                    <Box
                                        component="img"
                                        sx={{
                                            width: '100%',
                                            display: 'block',
                                            overflow: 'hidden',
                                            height: { xs: '8em', sm: '12em', md: '15em', lg: '17em' },
                                        }}
                                        src={step.img}
                                        alt={step.name}
                                    />
                                ) : null}
                            </div>
                        ))}
                    </AutoPlaySwipeableViews>
                </Box>
                <MobileStepper
                    steps={maxSteps}
                    position="static"
                    nextButton={false}
                    backButton={false}
                    activeStep={activeStep}
                    sx={{ mt: 1, backgroundColor: 'transparent' }}
                />
            </Box>

            {/* // Product List // */}
            <Box
                sx={{
                    width: '94%',
                    display: 'flex',
                    paddingBottom: 4,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    alignItems: 'center',
                    flexDirection: 'column',
                    marginTop: { xs: 6, lg: 10 },
                }}
            >
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                }}>
                    <Typography
                        color={common.black}
                        sx={{
                            mb: 2,
                            fontWeight: '500',
                            fontFamily: 'Montserrat',
                            textTransform: 'uppercase',
                            fontSize: { xs: 10, sm: 18, md: 20 },
                        }}
                    >
                        product list
                    </Typography>
                </Box>

                <Grid container sx={{
                    width: '100%',

                    paddingTop: 1,
                    paddingBottom: 3,

                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-around'
                }}>
                    {dataProduct.slice(0, 3).map((item) => {
                        return (
                            <Grid item xs={3.83} sm={3.83} sx={{
                                mb: 4,
                                p: 0.75,
                                borderRadius: 1,
                                backgroundColor: common.white,
                                boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'
                            }}>
                                <div>
                                    <img
                                        src={item.img}
                                        style={{
                                            width: '100%',
                                            height: '24vw',
                                            borderRadius: '1vw',
                                            objectFit: 'cover'
                                        }}
                                    />
                                    <Typography
                                        color={common.black}
                                        sx={{
                                            mt: { xs: 1, sm: 2 },
                                            mr: { xs: 1, sm: 2 },
                                            ml: { xs: 1, sm: 2 },
                                            fontWeight: 'bold',
                                            fontFamily: 'Roboto',
                                            textTransform: 'capitalize',
                                            fontSize: { xs: 6, sm: 12, md: 18, lg: 22 },
                                            

                                            overflow: 'hidden',
                                            WebkitLineClamp: 2,
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                        }}
                                    >
                                        {item.name}
                                    </Typography>
                                    <Typography
                                        color={common.black}
                                        sx={{
                                            mr: { xs: 1, sm: 2 },
                                            ml: { xs: 1, sm: 2 },
                                            fontWeight: '600',
                                            fontFamily: 'Montserrat',
                                            textTransform: 'capitalize',
                                            fontSize: { xs: 4, sm: 8, md: 10, lg: 14 },

                                            overflow: 'hidden',
                                            WebkitLineClamp: 2,
                                            display: '-webkit-box',
                                            WebkitBoxOrient: 'vertical',
                                        }}
                                    >
                                        {item.proyek}
                                    </Typography>
                                </div>

                                <Typography
                                    color={'#999999'}
                                    sx={{
                                        mt: { xs: 1, sm: 3 },
                                        mr: { xs: 1, sm: 2 },
                                        ml: { xs: 1, sm: 2 },
                                        maxLines: 2,
                                        fontWeight: '400',
                                        fontFamily: 'Roboto',
                                        textTransform: 'capitalize',
                                        fontSize: { xs: 6, sm: 8, md: 16 },

                                        overflow: 'hidden',
                                        WebkitLineClamp: 3,
                                        display: '-webkit-box',
                                        WebkitBoxOrient: 'vertical',
                                    }}
                                >
                                    {item.desc}
                                </Typography>

                                <div>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: { xs: 'column', md: 'row' },
                                        alignItems: { xs: 'flex-start', md: 'flex-end' },
                                        mt: { xs: 2, sm: 4 },
                                        mb: { xs: 0.5, sm: 1 },
                                        pl: { xs: 1, sm: 2 },
                                        pr: { xs: 1, sm: 2 },
                                        justifyContent: { xs: 'flex-start', md: 'space-between' }
                                    }}>
                                        <Typography
                                            color={common.black}
                                            sx={{
                                                fontWeight: '400',
                                                fontFamily: 'Roboto',
                                                textTransform: 'capitalize',
                                                fontSize: { xs: 3, sm: 6, md: 8, lg: 12 },
                                            }}
                                        >price from</Typography>
                                        <Typography
                                            color={common.black}
                                            sx={{
                                                fontWeight: '700',
                                                fontFamily: 'Roboto',
                                                textTransform: 'capitalize',
                                                fontSize: { xs: 6, sm: 12, md: 16, lg: 20 },
                                            }}
                                        >{formatRupiah(item.price)}</Typography>
                                    </Box>
                                    <Button
                                        fullWidth
                                        size='small'
                                        variant='contained'
                                        sx={{ 
                                            fontSize: { xs: 7, sm: 12, md: 18 },
                                            borderRadius: { xs: 1, sm: 1.5, md: 2 },
                                            py: { xs: 0.5, sm: 1, md: 1 }
                                        }}
                                        onClick={() => navigate(`/product/${item.id}`)}
                                    >Detail</Button>
                                </div>
                            </Grid>
                        )
                    })}
                </Grid>
                <Button
                    onClick={() => navigate('/products')}
                    size='small'
                    variant='outlined'
                    sx={{
                        borderRadius: 1,
                        fontSize: { xs: 8, sm: 12, md: 16 },
                    }}
                >
                    {'SEE MORE...'}
                </Button>
            </Box>

            {/* // What's On // */}
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    pt: 6,
                    pb: 12,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    alignItems: 'center',
                    flexDirection: 'column',
                    marginTop: { xs: 6, lg: 10 },
                    backgroundColor: '#F5F5F5'
                }}
            >
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                }}>
                    <Typography
                        color={common.black}
                        sx={{
                            mb: 4,
                            fontWeight: '500',
                            fontFamily: 'Montserrat',
                            textTransform: 'uppercase',
                            fontSize: { xs: 10, sm: 18, md: 20 },
                        }}
                    >
                        what's on
                    </Typography>
                </Box>

                <Grid container sx={{
                    width: '90%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                }}>
                    {dataWhatsOn.slice(0, 2).map((item) => {
                        return (
                            <Grid item xs={5.75} sm={5.75} sx={{
                                mb: 4,
                                flex: 1,
                                height: '100%',
                                display: 'flex',
                                borderRadius: 1,
                            }}>
                                <Link to={item.source} target='_blank' style={{ width: '100%' }}>
                                    <Box
                                        sx={{
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'flex-end',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundImage: `url(${item.img})`,
                                            height: { xs: 120, sm: 180, md: 240, lg: 300 },
                                            borderRadius: { xs: '1em', sm: '1.75em', md: '2em', lg: '2.5em' },
                                        }}
                                    >
                                        <Box sx={{
                                            height: { xs: 46, sm: 72 },
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            backgroundColor: 'rgba(0, 128, 96, 0.8)',
                                            borderBottomLeftRadius: { xs: '1em', sm: '1.75em', md: '2em', lg: '2.5em' },
                                            borderBottomRightRadius: { xs: '1em', sm: '1.75em', md: '2em', lg: '2.5em' },
                                        }}>
                                            <Typography
                                                color={common.white}
                                                sx={{
                                                    width: '86%',
                                                    fontWeight: '600',
                                                    fontFamily: 'Montserrat',
                                                    fontSize: { xs: '0.4em', sm: '0.6em', md: '0.7em', lg: '0.8em' },


                                                    overflow: 'hidden',
                                                    WebkitLineClamp: 2,
                                                    display: '-webkit-box',
                                                    WebkitBoxOrient: 'vertical',
                                                }}
                                            >{item.title}</Typography>
                                            <Typography
                                                color={common.white}
                                                sx={{
                                                    width: '86%',
                                                    fontWeight: '200',
                                                    fontFamily: 'Roboto',
                                                    fontSize: { xs: '0.3em', sm: '0.5em', md: '0.6em', lg: '0.7em' },
                                                }}
                                            >{moment(item.created_at, "YYYY-MM-DD").format("dddd, MMMM Do YYYY")}</Typography>
                                        </Box>
                                    </Box>
                                </Link>
                            </Grid>
                        )
                    })}
                </Grid>
            </Box>

            {/* // Footer // */}
            <FooterComponent />

        </Stack>
    )
};